export default "__VITE_ASSET__DoXG_miS__"